import React from "react"
import { useTranslation } from "react-i18next"

import { Checkbox } from "components"
import classes from "./TdFormShapeSizes.module.scss"
import clsx from "clsx"

const sizes = ["small", "medium", "large"]
const sizesInFarsi = ["کوچک", "معمولی", "بزرگ"]

const TdFormShapeSizes = props => {
  const { setForm, form } = props

  const [t, i18n] = useTranslation()

  const handleChange = (value, name) => {
    setForm(prev => ({
      ...prev, [name]: value
    }))
  }

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <div className={classes["item"]}>
      <div className={classes["title"]}>
        {t("شکل_میز")}
      </div>
      <div className={classes["shapes"]}>
        {sizes.map((size, sIndex) =>
          <button
            key={size}
            onClick={() => handleChange(size, "scale")}
            className={clsx(
              classes["checkboxContainer"],
              isLtr && classes["checkboxContainer-ltr"]
            )}
          >
            <Checkbox
              checked={form.scale === size}
            />
            <span
              className={clsx(
                classes["text"],
                isLtr && classes["text-ltr"]
              )}
            >
              {t(sizesInFarsi[sIndex])}
            </span>
          </button>
        )}
      </div>
    </div>
  )
}

export default TdFormShapeSizes